// extracted by mini-css-extract-plugin
export var card = "ArticleLanding-module--card--b5f59";
export var container = "ArticleLanding-module--container--02be3";
export var featured = "ArticleLanding-module--featured--33446";
export var recentPosts = "ArticleLanding-module--recentPosts--8ea57";
export var top = "ArticleLanding-module--top--c74ff";